import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { getRequest, postRequest, deleteRequest } from "../helpers/fetchHandler"

const campaignKeys = {
  all: ["campaigns"] as const,
  byActivity: (activityId: string | undefined) => ["campaigns", activityId] as const
}

export function useCampaigns(activityId: string | undefined) {
  return useQuery({
    queryKey: campaignKeys.byActivity(activityId),
    queryFn: () => getRequest({ url: `/api/v1/campaigns/activity/${activityId}`, auth: true }),
    enabled: !!activityId
  })
}

export function useCreateCampaign() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => postRequest({ url: "/api/v1/campaigns", data, auth: true }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.all })
    }
  })
}

export function useDeleteCampaign() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteRequest({ url: `/api/v1/campaigns/${id}`, auth: true }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.all })
    }
  })
}
